export default {
	list: 'Buyout',
	grid: {
		gridId: 'buyoutGrid',
		checkbox: true,
		edit: true,
		delete: true,
		height: 800,
		pageSize: 100,
		groupable: true,
	},
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		PartnerFullName: {
			class: "lookup",
			dataName: 'Partner/FullName',
			type: 'string',
			title: 'Partner',
			width: 100,
			hidden: true,
			readOnly: true
		},
		PartnerLeaveDate: {
			class: 'lookup',
			dataName: 'Partner/LeaveDate',
			type: 'date',
			title: 'Partner Leave Date',
			width: 100,
			hidden: true,
			readOnly: true
		},
		ProgramTitle: {
			class: 'lookup',
			dataName: 'Program/Title',
			type: 'string',
			title: 'Program',
			width: 230,
			hidden: false,
			readOnly: true
		},
		PartnerId: {
			class: "lookup",
			dataName: 'PartnerId',
			type: 'number',
			title: 'PartnerId',
			width: 100,
			hidden: true,
			readOnly: false
		},
		PartnerID: {
			class: "lookup",
			dataName: 'Partner/PartnerID',
			type: 'number',
			title: 'Partner ID',
			width: 100,
			hidden: true,
			readOnly: true
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'ProgramId',
			type: 'number',
			title: 'ProgramId',
			width: 100,
			hidden: true,
			readOnly: false
		},
		UnitType: {
			class: 'choice',
			dataName: 'UnitType',
			type: 'string',
			title: 'Unit Type',
			width: 185,
			hidden: false,
			readOnly: false
		},
		UnitClass: {
			class: 'choice',
			dataName: 'UnitClass',
			type: 'string',
			title: 'Unit Class',
			width: 185,
			hidden: false,
			readOnly: false
		},
		UnitPool: {
			class: 'choice',
			dataName: 'UnitPool',
			type: 'string',
			title: 'Unit Pool',
			width: 185,
			hidden: false,
			readOnly: false
		},
		Unit: {
			class: 'value',
			dataName: 'Unit',
			type: 'number',
			title: 'Awarded Units',
			width: 215,
			hidden: false,
			readOnly: false,
			template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", Unit!=null?Unit:0 )#</span>',
		},
		UnitPrice: {
			class: 'value',
			dataName: 'UnitPrice',
			type: 'currency',
			title: 'Unit Price',
			template: '<span class="number-cell-ui">#=kendo.toString(UnitPrice!=null?kendo.parseInt(UnitPrice):0, "c")#</span>',
			width: 185,
			hidden: false,
			readOnly: false
		},
		VestedUnit: {
			class: 'value',
			dataName: 'VestedUnit',
			type: 'number',
			title: 'Vested Units',
			width: 205,
			hidden: false,
			readOnly: false,
			template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", VestedUnit!=null?VestedUnit : 0 ) #</span>',
		},
		VestPercentage: {
			class: 'value',
			dataName: 'VestPercentage',
			type: 'number',
			title: 'Vested %',
			width: 185,
			hidden: false,
			readOnly: true,
			template: '<span class="number-cell-ui">#=kendo.format("{0:p}", VestPercentage!=null?VestPercentage:0)#</span>',
		},
		RetainedUnit: {
			class: 'value',
			dataName: 'RetainedUnit',
			type: 'number',
			title: 'Units Retained in Excess of Vesting',
			width: 260,
			hidden: false,
			readOnly: false,
			template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", RetainedUnit!=null?RetainedUnit:0 )#</span>',
		},
		TotalRetainedUnit: {
			class: 'value',
			dataName: 'TotalRetainedUnit',
			type: 'number',
			title: 'Total Units Retained',
			width: 290,
			hidden: false,
			readOnly: true,
			template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", TotalRetainedUnit!=null?TotalRetainedUnit:0 )#</span>',
		},
		ForfeitedUnit: {
			class: 'value',
			dataName: 'ForfeitedUnit',
			type: 'number',
			title: 'Forfeited Units',
			width: 215,
			hidden: false,
			readOnly: true,
			template: '<span class="number-cell-ui">#=kendo.format("{0:n2}",ForfeitedUnit!=null?ForfeitedUnit:"")#</span>',
		},
		Status: {
			class: 'choice',
			dataName: 'Status',
			type: 'string',
			title: 'Status',
			width: 150,
			hidden: true,
			readOnly: false
		},
		WorkflowStatus: {
			class: 'choice',
			dataName: 'WorkflowStatus',
			type: 'string',
			title: 'Status',
			width: 100,
			hidden: true,
			readOnly: true
		},
		ConvertToTreasury: {
			class: 'choice',
			dataName: 'ConvertToTreasury',
			type: 'string',
			title: 'ConvertToTreasury',
			width: 200,
			hidden: false,
			readOnly: false
		},
		AmountPayable: {
			class: "value",
			dataName: 'AmountPayable',
			type: 'currency',
			title: 'Amount Payable to Partner',
			width: 290,
			hidden: false,
			editable: false,
			readOnly: true,
			template: '<span class="number-cell-ui">#=kendo.toString(AmountPayable!=null?kendo.parseInt(AmountPayable):0, "c")#</span>',

		},
		AmountReceivable: {
			class: "value",
			dataName: 'AmountReceivable',
			type: 'currency',
			title: 'Amount Receivable from Partner',
			width: 290,
			hidden: false,
			editable: false,
			readOnly: true,
			template: '<span class="number-cell-ui">#=kendo.toString(AmountReceivable!=null? kendo.parseInt(AmountReceivable):0, "c")#</span>',
		},
		AmountPaidForProgram: {
			class: 'value',
			dataName: 'AmountPaidForProgram',
			type: 'currency',
			template: '<span class="number-cell-ui">#=kendo.toString(AmountPaidForProgram!=null?kendo.parseInt(AmountPaidForProgram):0, "c")#</span>',
			title: 'Amount Paid for Program',
			width: 350,
			hidden: false,
			readOnly: false
		},
		AmountPaid: {
			class: 'value',
			dataName: 'AmountPaid',
			type: 'currency',
			template: '<span class="number-cell-ui">#=kendo.toString(AmountPaid!=null?kendo.parseInt(AmountPaid):0, "c")#</span>',
			title: 'Amount Paid for Units',
			width: 300,
			hidden: false,
			readOnly: false
		},
		BuyoutAmount: {
			class: 'value',
			dataName: 'BuyoutAmount',
			type: 'currency',
			title: 'Buyout Amount Paid',
			width: 250,
			hidden: false,
			readOnly: true,
			template: '<span class="number-cell-ui">#=kendo.toString(BuyoutAmount!=null?kendo.parseInt(BuyoutAmount):0, "c")#</span>',
		},
		AmountOwed: {
			class: "value",
			dataName: 'AmountOwed',
			type: 'currency',
			title: 'Amount Owed',
			width: 210,
			hidden: false,
			editable: false,
			readOnly: true,
			template: '<span class="number-cell-ui">#=kendo.toString(AmountOwed!=null?kendo.parseInt(AmountOwed):0, "c")#</span>',
		},
		ContributionRelief: {
			class: 'value',
			dataName: 'ContributionRelief',
			type: 'currency',
			title: 'Contribution Relief',
			width: 250,
			hidden: false,
			readOnly: true,
			template: '<span class="number-cell-ui">#=kendo.toString(ContributionRelief!=null?kendo.parseInt(ContributionRelief):0, "c")#</span>',
		},
		PayoutAmount: {
			class: 'value',
			dataName: 'PayoutAmount',
			type: 'currency',
			title: 'Net Pay Out to Partner/(Amount Partner Owes to Program)',
			width: 350,
			hidden: false,
			readOnly: true,
			template: '<span class="number-cell-ui">#=kendo.toString(PayoutAmount!=null?kendo.parseInt(PayoutAmount):0, "c")#</span>',
		},
		VestingType: {
			class: 'value',
			dataName: 'VestingType',
			type: 'string',
			title: 'Vesting Type',
			width: 350,
			hidden: true,
			readOnly: false,
		},
		VestingLogged: {
			class: 'value',
			dataName: 'VestingLogged',
			type: 'string',
			title: 'Vesting Logged',
			width: 350,
			hidden: true,
			readOnly: false,
		}
	}
}